/* eslint-disable import/no-extraneous-dependencies */
import { useContext } from 'react';

import JobListContext from '../app/context/jobListContext';
import PlannedJob from "../app/interfaces/plannedJob";

const usePlannedSearch = () => {
  const { filtersPlanned, plannedJobList, updateFilteredPlannedJobList, filteredPlannedJobList } = useContext(
    JobListContext
  );

  const handleSearch = (event: any) => {
    if (event) {
      event.preventDefault();
      let jobList = [];

      if (filtersPlanned.maintenanceFilter.length > 0 || filtersPlanned.statusFilter.length > 0) {
        jobList = filteredPlannedJobList;
      } else {
        jobList = plannedJobList;
      }

      updateFilteredPlannedJobList(
        jobList.filter((job:PlannedJob) => {
          // ADD MORE FILTER CRITERIAS
          return (
            job.ItemDescription.toString()
              .toLowerCase()
              .indexOf(event.target.value.toLowerCase()) >= 0 ||
            job.Status.toString()
              .toLowerCase()
              .indexOf(event.target.value.toLowerCase()) >= 0 ||
            job.UnitLocation.toString()
              .toLowerCase()
              .indexOf(event.target.value.toLowerCase()) >= 0 ||
            job.CustomerName.toString()
              .toLowerCase()
              .indexOf(event.target.value.toLowerCase()) >= 0 ||
            job.CallNo.toString()
              .toLowerCase()
              .indexOf(event.target.value.toLowerCase()) >= 0 ||
            job.PMCallNo.toString()
              .toLowerCase()
              .indexOf(event.target.value.toLowerCase()) >= 0
          );
        })
      );
    }
  };

  return {
    handleSearch,
  };
};

export default usePlannedSearch;
